import { calculateWordCount } from '../../lib/utils/strings'

const emailRegex = /^[^@\s]+@[^@\s]+\.[^@\s]+$/iu

export type TextLimitConfig = {
  maxCharacterLimit: number
  showErrorText: boolean
  minCharacterLimit?: number
  anonymousCharacterLimit?: number
  useWordLimit?: boolean
}

export const getMaxCharacterLimit = (maxLength?: number, hasLongformText?: boolean): number => {
  return maxLength ? maxLength : hasLongformText ? 3000 : 600
}

export const charactersToWords = 5

export const isValidEmail = (val: string): boolean => {
  return emailRegex.test(val)
}

const isValidCharacterLimit = (val: string, maxLength: number): boolean => {
  return val.length <= maxLength
}

export const isValidAnonymousTextLimit = (val: string, textLimit: TextLimitConfig) => {
  const { anonymousCharacterLimit, useWordLimit } = textLimit

  if (anonymousCharacterLimit) {
    if (useWordLimit) {
      const wordCount = calculateWordCount(val)
      return wordCount <= Math.floor(anonymousCharacterLimit / charactersToWords)
    }
    return isValidCharacterLimit(val, anonymousCharacterLimit)
  }

  return true
}

export const isValidTextLimit = (val: string, textLimit: TextLimitConfig) => {
  const { maxCharacterLimit, useWordLimit } = textLimit

  if (useWordLimit) {
    // Check for adversarial inputs first with no spaces.
    const twiceMaxCharacterLimit = maxCharacterLimit * 2
    if (!isValidCharacterLimit(val, twiceMaxCharacterLimit)) {
      return false
    }

    const wordCount = calculateWordCount(val)

    return wordCount <= Math.floor(maxCharacterLimit / charactersToWords)
  }
  return isValidCharacterLimit(val, maxCharacterLimit)
}

export const isValidMinCharacterLimit = (val: string, textLimit: TextLimitConfig) => {
  const { minCharacterLimit, useWordLimit } = textLimit

  if (!minCharacterLimit) {
    return true
  }

  if (useWordLimit) {
    const wordCount = calculateWordCount(val)
    return wordCount >= Math.floor(minCharacterLimit / charactersToWords)
  }

  return val.length >= minCharacterLimit
}

export const hasRestrictedValue = (val: string, restrictedValues: string[] | undefined) => {
  return restrictedValues?.some((restrictedValue) => val.includes(restrictedValue))
}
